import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#171716',
	secondary: '#1F1F1F',
	snackbar: '#000000',
	input: '#3E3C37',
	modalView: convertHexToRgbA('#292621', 0.8),
	modalViewSecondary: convertHexToRgbA('#171716', 0.8)
};

export const TRANSPARENT = {
	light10: convertHexToRgbA('#ffffff', 0.1),
	light15: convertHexToRgbA('#ffffff', 0.15),
	light20: convertHexToRgbA('#ffffff', 0.2),
	light30: convertHexToRgbA('#ffffff', 0.3),
	light45: convertHexToRgbA('#ffffff', 0.45),
	light50: convertHexToRgbA('#ffffff', 0.5),
	light60: convertHexToRgbA('#ffffff', 0.6)
};

export const ICON = {
	main: '#F6CA21',
	secondary: '#969186',
	chevron: '#776f60',
	hover: '#b5afa2',
	pressed: '#767167',
	alwaysWhite: '#ffffff',
	notification: '#F40A0A',
	warning: '#e2662c',
	deposit: '#16c481'
};

export const CONTROL = {
	primary: '#FDD437',
	hover: '#FFCA00',
	pressed: '#D8AB00',
	disabled: '#343435',
	secondary: '#00D07F',
	secondaryHover: '#02B570',
	secondaryPressed: '#038351',
	dark: '#37332D',
	darkHover: '#413D37',
	darkPressed: '#413d37',
	darkToggle: '#61605F',
	light: '#ffffff',
	lightHover: '#E5E5E5',
	lightPressed: '#D9D9D9',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#F8F8F8',
	subtitle: '#E3E3E3',
	body: '#CDCCCA',
	link: '#00D68F',
	error: '#FF6964',
	warning: '#ec985b',
	alwaysWhite: '#ffffff',
	alwaysDark: '#1F1F1F'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#1F1F1F', 0.8),
	calendarActive: '#1F1F1F',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#333217',
	calendarTextYellow: '#EAAE16',
	calendarBackgroundDarkGreen: '#014A2E',
	calendarTextGreen: '#00D07F',
	calendarBackgroundDarkPurple: '#3A2159',
	calendarTextPurple: '#8F6ED4',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};

export const TAG = {
	textGreen: '#009E69',
	bgGreen: convertHexToRgbA('#009E69', 0.1),
	textBlue: '#2F8FC7',
	bgBlue: convertHexToRgbA('#2F8FC7', 0.1),
	textYellow: '#F6CA21',
	bgYellow: convertHexToRgbA('#F6CA21', 0.1),
	textRed: '#F40A0A',
	bgRed: convertHexToRgbA('#F40A0A', 0.1)
};

export const GAME_TAG_LOGO = {
	dota2Bg: convertHexToRgbA('#FF3333', 0.2),
	dota2Logo: '#FF3333',
	cs2Bg: convertHexToRgbA('#E2B603', 0.15),
	lolBg: convertHexToRgbA('#C79B3B', 0.15),
	lolLogo: '#C79B3B'
};
